import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { CountryInput } from './CountryInput';

export function CountryField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return <GenericInputField<TValues> {...props} Input={CountryInput} />;
}
